import React, {useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";
import {Tooltip} from "@material-ui/core";
import DataGrid from "../../../controls/DataGrid";
import AogActivity from "./AogActivity";
import { useScheduledMaintenance } from "../../../services/aircraft";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#e5e5e5',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    maxWidth: 'none'
  },
}))(Tooltip);


const AircraftScheduledMaintenanceDialog = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const dataGridRef = useRef();

  const queryClient = useQueryClient();
  const extraKeys = [props.aircraftTailNumber];

  const aircraftMaintenance = useScheduledMaintenance({queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellStyle: { fontSize:14 },
      },
      editable: props.canEdit,
    };

    return [
      {
        ...baseColumn,
        headerName: "Scheduled Start",
        field: "startCheckDate",
        width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Scheduled End",
        field: "endCheckDate",
        width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Check",
        field: "aircraftCheck",
        width: 100,
        cellEditor: {
          component: "ComboSelect",
          params: {
            id: "aircraftCheck",
            //isdatagrid: true,
            displayOnly: true,
            value: props.value,
            group: "MAINTENANCE CODES",
            subGroup: "ACTIVE",
            style: {width:"100%", fontSize: "0.875rem", textAlign: "left"},
          }
        },
      },
      {
        ...baseColumn,
        headerName: "Check Info",
        field: "mxAircraftCheckInfo",
        width: 190,
        autoHeight: true,
        wrapText: true
      },
      {
        ...baseColumn,
        headerName: "Airport",
        field: "mxAirportCode",
        width: 100,
        autoHeight: true,
        wrapText: true
      },
      {
        ...baseColumn,
        headerName: "Duration",
        field: "startCheckDate",
        width: 150,
        valueFormatter: (params)=> {
          const end = moment(params.data.endCheckDate);
          const start = moment(params.data.startCheckDate);
          const duration = moment.duration(end.diff(start, 'hours', true), 'hours');
          const days = Math.floor(duration?.asDays());
          const hours = Math.floor(duration?.asHours() % 24);
          const displayDuration = `${days && days !== 0 ? `${days} days` : ""}${days && days !== 0 && hours && hours !== 0 ? ", ": ""}${hours && hours !== 0 ? `${hours} hours` : ""}`;
          return (`${displayDuration}`);
        }
      },
      {
        ...baseColumn,
        headerName: "Notes",
        field: "notes",
        flex: 1,
        autoHeight: true,
        wrapText: true,
        cellRendererSelector: (params) => {return {
          component: "Wrapper",
          params: {
            component: (
              <LightTooltip title={<AogActivity activity={params.data.aogActivities}/>} arrow>
                <span>{params.value}</span>
              </LightTooltip>
            )
          }
        }},
      },
      // {
      //   ...baseColumn,
      //   headerName: "Origin",
      //   field: "auditText",
      //   options: {
      //     ...baseColumn.options,
      //     flex: 1
      //   }
      // },
    ];
  };

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="AircraftScheduledMaintenance"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={aircraftMaintenance.data}
        height={props.height||"300px"}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default AircraftScheduledMaintenanceDialog;
